import styles from './style.postcss';
import React from 'react';
import classnames from 'classnames';
import is from 'is_js';
import { testClass } from 'omni-common-ui';
import PropTypes from 'prop-types';

const ReadOnlyField = (props) => {
  const classesBoard = classnames(styles.ReadOnlyField_board, props.className);
  const classesH5 = classnames(styles.ReadOnlyField_h5, testClass('field-title'));
  const classesP = classnames(styles.ReadOnlyField_p, testClass('field-value'));

  return <div className={classesBoard}>
    <h5 className={classesH5}>{props.boardTitle}</h5>
    <p className={classesP}>{judgeValue(props.boardValue)}</p>
  </div>;

  function judgeValue(boardValue) {
    if (! is.not.undefined(boardValue) || ! boardValue || boardValue === '') {
      return '–';
    }
    return boardValue;
  }
};

ReadOnlyField.propTypes = {
  boardTitle: PropTypes.string.isRequired,
  boardValue: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ReadOnlyField;



// WEBPACK FOOTER //
// ./containers/Group/IndividualDevelopmentPlan/IndividualDevelopmentPlanDetailView/ReadOnlyField/index.jsx